import { c } from "react/compiler-runtime";
import { useCache } from "@effektify/cache";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { QUERY_KEYS } from "../constants.js";
import useLogger from "./useLogger.js";
import useParseConfig from "./useParseConfig.js";
import { findAllCmsTags } from "../utils/findCmsTags.js";
import { isConfig } from "../types/src/guards/config.js";
import fetchConfig from "../api/fetchConfig.js";
const useGetConfig = t0 => {
  const $ = c(27);
  const {
    getToken,
    configURI
  } = t0;
  const logger = useLogger("useGetConfig");
  let t1;
  if ($[0] !== getToken) {
    t1 = fetchConfig(getToken);
    $[0] = getToken;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const configFetcher = t1;
  const {
    updateVariables
  } = useCache();
  const queryEnabled = !!configURI;
  let t2;
  if ($[2] !== configURI) {
    t2 = [QUERY_KEYS.REPORT_CONFIG, configURI];
    $[2] = configURI;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== configFetcher || $[5] !== configURI) {
    t3 = () => configFetcher({
      configURI
    });
    $[4] = configFetcher;
    $[5] = configURI;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== queryEnabled || $[8] !== t2 || $[9] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      staleTime: 9e5,
      enabled: queryEnabled,
      throwOnError: true
    };
    $[7] = queryEnabled;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: configResponse,
    isLoading,
    isError
  } = useQuery(t4);
  const config = useParseConfig(configResponse);
  let t5;
  bb0: {
    if (config instanceof Error || !isConfig(config)) {
      if (config instanceof Error) {
        logger.error("Error parsing config:", config.message);
      }
      let t63;
      if ($[11] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
        t63 = {
          report: null,
          configuration: null,
          fields: null,
          cmsTags: {}
        };
        $[11] = t63;
      } else {
        t63 = $[11];
      }
      t5 = t63;
      break bb0;
    }
    let t62;
    if ($[12] !== config) {
      t62 = findAllCmsTags(config);
      $[12] = config;
      $[13] = t62;
    } else {
      t62 = $[13];
    }
    const cmsTags = t62;
    const t72 = config?.report || null;
    const t82 = config?.configuration || null;
    const t9 = config?.fields || null;
    let t10;
    if ($[14] !== cmsTags || $[15] !== t72 || $[16] !== t82 || $[17] !== t9) {
      t10 = {
        report: t72,
        configuration: t82,
        fields: t9,
        cmsTags
      };
      $[14] = cmsTags;
      $[15] = t72;
      $[16] = t82;
      $[17] = t9;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    t5 = t10;
  }
  const parsed = t5;
  let t6;
  let t7;
  if ($[19] !== config || $[20] !== updateVariables) {
    t6 = () => {
      if (config instanceof Error || !isConfig(config)) {
        return;
      }
      const {
        variables: t82
      } = config.configuration || {};
      const variables = t82 === void 0 ? {} : t82;
      updateVariables(variables);
    };
    t7 = [config, updateVariables];
    $[19] = config;
    $[20] = updateVariables;
    $[21] = t6;
    $[22] = t7;
  } else {
    t6 = $[21];
    t7 = $[22];
  }
  useEffect(t6, t7);
  let t8;
  if ($[23] !== isError || $[24] !== isLoading || $[25] !== parsed) {
    t8 = {
      data: parsed,
      isLoading,
      isError
    };
    $[23] = isError;
    $[24] = isLoading;
    $[25] = parsed;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};
export { useGetConfig as default };